import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";
import { ProductEnum } from "@p1s/p1s-common-react/constants";

class UserService {
    resetPassword(userId) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + 'user/password/reset/' + userId);
    }

    getUsersByOrgId(orgId) {
        return axios.get(UrlHelper.getIdentifiApiUrl() + 'users/getByOrgId/' + orgId);
    }

    getUserById(userId) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + 'users/' + userId);
    }

    getUserByLogin(request) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'users/getByLogin', request);
    }

    getUserByToken() {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'auth/validateSessionExternal?virtualProductId=' + ProductEnum.UserManagement.id);
    }

    changePassword(request,) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'user/password/changeForUser', request);
    }

    ssoLinkUser(request) {
        return axios
            .post(UrlHelper.getIdentifiUrl() + 'AuthActions/UpgradeToSsoVirtualUser', request);
    }

    create(request) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "users/new", request);
    }

    restrict(request) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "user/products/restrict", request);
    }

    saveUserContact(request) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "users", request);
    }

    generatePassword(orgId) {
        return axios
            .get(UrlHelper.getIdentifiApiUrl() + 'organizations/password/generate/' + orgId);
    }

    changePasswordAndLogin (request) {
        return axios
            .post(UrlHelper.getIdentifiUrl() + 'AuthActions/LegacyLoginForExpiredPassword', request);
    }

    ssoStartLogin (request) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "sso/auth/login", request);
    }

    startLogin (request) {
        return axios
            .post(UrlHelper.getIdentifiUrl() + "AuthActions/LegacyLogin", request);
    }

    assign(data) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + "user/role/assign", data);
    }

    activate(userId) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "users/activate/" + userId);
    }

    inactivate(userId) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + "users/inactivate/" + userId);
    }

    resendVerifyEmail (email) {
        const request = {
            Email: email
        };

        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "auth/email/resendVerificationEmail", request);
    }

    extend(data) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + "user/products/extend", data);
    }

    unlock (userId) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'users/unlock/' + userId);
    }
}

export default new UserService();
